import get from 'lodash/get';
import { level2BuySelector, level2SellSelector } from '../selectors/level2Selectors';
import { unsubscribeLevel2, getLevel2Data, UNSUBSCRIBE_LEVEL2, REQUEST_LEVEL_2_DATA } from '../actions/level2Actions';
import { selectedInstrumentSelector } from '../selectors/instrumentPositionSelectors';
import config from '../../config';
var level2MonitorInterval = config.Middleware.level2MonitorInterval;
var intervalSingleton = void 0;
var orderBookSanityCheck = function orderBookSanityCheck(state) {
  var buy = level2BuySelector(state, {});
  var sell = level2SellSelector(state, {});
  var InsideBid = get(buy, [buy.length - 1, 'Price'], 0);
  var InsideAsk = get(sell, [0, 'Price'], Number.MAX_VALUE);
  return InsideBid > InsideAsk;
};
var level2monitor = function level2monitor(store) {
  return function (next) {
    return function (action) {
      if (action.type === REQUEST_LEVEL_2_DATA) {
        intervalSingleton = setInterval(function () {
          var state = store.getState();
          if (orderBookSanityCheck(state)) {
            var _selectedInstrumentSe = selectedInstrumentSelector(state),
              InstrumentId = _selectedInstrumentSe.InstrumentId;
            store.dispatch(unsubscribeLevel2(InstrumentId));
            store.dispatch(getLevel2Data(InstrumentId));
          }
        }, level2MonitorInterval);
      }
      if (action.type === UNSUBSCRIBE_LEVEL2) {
        window.clearInterval(intervalSingleton);
      }
      return next(action);
    };
  };
};
export default level2monitor;